<template>
  <GetStartedInstructions
    :localStorageKey="localStorageKey"
    :showDismiss="false"
    :showTitleWhenExpanded="false"
    :startCollapsed="false"
    title="Learn more about JumpCloud reports"
  >
    <div :class="$style.container">
      <h4 :class="$style.header">
        Welcome to JumpCloud Reports
      </h4>
      <p :class="$style.message">
        JumpCloud Reports makes it easy for you to pull essential and critical data to help
        meet compliance, assess governance, and evaluate security posture.
      </p>
      <ul :class="$style.list">
        <li>
          Easily and quickly get an overview on the devices, directories, RADIUS servers, etc.
          that associate with your users for better admin control, management, and planning.
        </li>
        <li>
          Eliminate manual report processing to save time and resources for more important tasks.
        </li>
        <li>
          Pull your required reports on a regular or ad hoc basis, with the most up-to-date data,
          so that you can repurpose them based on your needs.
        </li>
        <li>
          Create actionable insights for conversations with leadership and
          cross-functional stakeholders like HR, finance, auditors, security teams, etc.
        </li>
      </ul>
    </div>
  </GetStartedInstructions>
</template>

<script>
import { LocalStorageConsts } from 'client/util/Constants';
import GetStartedInstructions from 'components/GetStartedInstructions/GetStartedInstructions.vue';

export default {
  name: 'ReportsGetStartedInstructions',

  components: {
    GetStartedInstructions,
  },

  data: () => ({
    localStorageKey: LocalStorageConsts.reportsInstructionsDismissed,
  }),
};
</script>

<style module>
.container {
  font-size: var(--jcBodyLarge);
}

p.message {
  /* overwriting ".jc-ux2 p" legacy styles */
  margin-top: var(--jc-spacer);
}

ul.list {
  /* overwriting ".jc-ux2 ul" legacy styles */
  font-style: italic;
  margin-bottom: 0;
}
.list li { padding-bottom: var(--jc-spacer-x-small); }
.list li:last-child { padding-bottom: 0; }
</style>
